// extracted by mini-css-extract-plugin
module.exports = {"text_input":"TextInput_text_input__2L98Q","input_box":"TextInput_input_box__37e4u","helper_text":"TextInput_helper_text__30Sec","error_text":"TextInput_error_text__3wfNL"};